module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/sheshines-06-nov-2025.json
// module id = 1487
// module chunks = 203125409343400